export default "__VITE_ASSET__a770b6f4__"